import { Ikon } from '../status/Ikon.tsx';

/**
 * «Kopier» ved en verdi som ikke er hemmelig (M5.7): leietaker-ID, produkt-ID, API-adressen.
 * `hva` står i aria-label fordi knappen finnes flere ganger på samme side, og «Kopier» alene
 * sier ikke hvilken. Hemmeligheter kopieres ALDRI herfra — de vises én gang i en dialog
 * (DD-20), og tofaktor-skjermene har en vakt mot utklippstavlen (lint-vakter).
 */
export function Kopier({ hva, verdi, testid }: { hva: string; verdi: string; testid?: string }) {
  return (
    <button type="button" className="panel-knapp-lenke" onClick={() => void navigator.clipboard?.writeText(verdi)} aria-label={`Kopier ${hva}`} data-testid={testid}>
      <Ikon navn="copy-outline" /> Kopier
    </button>
  );
}
